export default function Stats() {
  const stats = [
    { value: "2.4M+", label: "Videos downloaded" },
    { value: "50K+", label: "Happy marketers" },
    { value: "99.9%", label: "Uptime" },
    { value: "4.9/5", label: "Average rating" },
  ];
  return (
    <section
      data-testid="stats-section"
      className="relative py-16 md:py-20 border-t border-zinc-200 dark:border-zinc-800 bg-zinc-100/60 dark:bg-zinc-950/40"
    >
      <div className="mx-auto max-w-7xl px-6">
        <div className="grid grid-cols-2 md:grid-cols-4 divide-x divide-zinc-200 dark:divide-zinc-800 border-x border-zinc-200 dark:border-zinc-800">
          {stats.map((s, i) => (
            <div
              key={s.label}
              data-testid={`stat-${i}`}
              className="p-6 md:p-8 group hover:bg-yellow-500/5 transition-colors"
            >
              <div className="font-display font-extrabold text-3xl sm:text-4xl md:text-5xl lg:text-6xl text-zinc-900 dark:text-white tracking-tight group-hover:text-yellow-500 transition-colors">
                {s.value}
              </div>
              <div className="mt-2 text-xs font-mono uppercase tracking-widest text-zinc-500 dark:text-zinc-500">
                {s.label}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
